import { render, staticRenderFns } from "./sidebarItem.vue?vue&type=template&id=7db438fb&scoped=true"
import script from "./sidebarItem.vue?vue&type=script&lang=js"
export * from "./sidebarItem.vue?vue&type=script&lang=js"
import style0 from "./sidebarItem.vue?vue&type=style&index=0&id=7db438fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db438fb",
  null
  
)

export default component.exports